module.exports = __webpack_public_path__ + "img/logo.cb11457f.png";